import React from "react";


export default function ValidateClientErrorComponent({errorMessage = "Something went wrong, Please contact support."}) {

  return (
    <div className="text-red-600 text-center font-bold mt-24 text-2xl font-notoSans">
      {errorMessage}
    </div>
  );
}
